export const setCookies = (cookies: Record<string, string>, path = '/') => {
    Object.entries(cookies).forEach(([key, value]) => {
        document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)};path=${path}`;
    });
};
